define([
	'service/QRCodeService',
	'view/UIView',
	'amdi18n-loader?!identity/nls/IdentityTransferView_strings',
	'lib/jquery'
], function (
	QRCodeService,
	UIView,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityTransferView class
	 */
	function IdentityTransferView() {
		var _qrCodeService = new QRCodeService(),
			_view;

		_view = (function () {
				var $view = jQuery("<div id='skIdS_identity-transfer-container'>" +
										"<p id='skIdS_identity-transfer-mobile-text'>" + Strings.info_mobile_text + "</p>" +
										"<p id='skIdS_identity-transfer-upper-text'>" + Strings.info_upper_text + "</p>" +
										"<p id='skIdS_identity-qrcode-url'></p>" +
										"<p id='skIdS_identity-transfer-lower-text'>" + Strings.info_lower_text + "</p>" +
										"<div id='skIdS_identity-qrcode-container'></div>" +
									"</div>");

//				$view.find('#skIdS_identity-qrcode-container').on('click', function () {
//					jQuery(this).toggleClass('skIdS_identity-qrcode-big');
//				})

				return $view;
			})();

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (url) {
			_view.find('#skIdS_identity-qrcode-url').html(url);

			_view.find('#skIdS_identity-qrcode-container').empty();

			_qrCodeService.encode(_view.find('#skIdS_identity-qrcode-container'), url);
		};
		
		this.setUrlVisible = function (isVisible) {
			if (isVisible) {
				_view.find('#skIdS_identity-transfer-mobile-text').hide();
				_view.find('#skIdS_identity-transfer-upper-text').show();
				_view.find('#skIdS_identity-qrcode-url').show();
				_view.find('#skIdS_identity-transfer-lower-text').show();
			} else {
				_view.find('#skIdS_identity-transfer-mobile-text').show();
				_view.find('#skIdS_identity-transfer-upper-text').hide();
				_view.find('#skIdS_identity-qrcode-url').hide();
				_view.find('#skIdS_identity-transfer-lower-text').hide();
			}
		};
	}

	IdentityTransferView.prototype = Object.create(UIView.prototype);

	return IdentityTransferView;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityTransferView.js
// module id = 158
// module chunks = 1